import { ServiceWithRFQID } from '@/services/Service'

const ENDPOINTS = {
  GET: 'RFQ2s/Get',
  GET_DYNAMIC: 'RFQ2s/GetAllDynamic',
  POST: 'RFQ2s/Create',
  PATCH: 'RFQ2s/Patch',
  PUT: 'RFQ2s/Put',
  DELETE: 'RFQ2s/Delete'
}

class ModuleServiceRFQ2s extends ServiceWithRFQID {
  getModel () {
    return {
      id: '',
      rfqid: '',
      supplierCompanyID: null,
      supplierCompanyName: '',
      supplierContactID: null,
      employeeID: '',
      entryDate: new Date(),
      partID: null,
      conditionID: null,
      qty: 1,
      price: '',
      currencyID: null,
      partSN: '',
      paymentTermID: null,
      priceMax: '',
      priceMin: '',
      releaseID: null,
      delivery: '',
      traceabilityCompanyID: null,
      estimatedDeliveryDate: null,
      tagInfoCompanyID: null,
      tagDate: null,
      remarks: null,
      typeOfOperationConditionID: null,
      reasonForRemoval: null,
      warrantyRequested: false
    }
  }
}
export const ServiceRFQ2s = new ModuleServiceRFQ2s({
  apiGet: ENDPOINTS.GET,
  apiGetDynamic: ENDPOINTS.GET_DYNAMIC,
  apiPost: ENDPOINTS.POST,
  apiPatch: ENDPOINTS.PATCH,
  apiPut: ENDPOINTS.PUT,
  apiDelete: ENDPOINTS.DELETE
})

export * from './models'
